import { visitModal } from '@inertiaui/modal-vue';
import { route } from 'ziggy-js';

export function loadWorkOrderDetails(workOrderId: string, config: Object = {}): Promise<any> {
    if (!workOrderId) {
        return Promise.resolve();
    }

    return visitModal(route('workorders.show', workOrderId), {
        config: {
            closeButton: false,
        },
        ...config,
    });
}
